import React, { ReactElement } from 'react';

import { Card } from 'src/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from 'src/components/ui/collapsible';
import { ProductCardHeader } from 'src/features/novelties/components/ProductCardHeader';
import { SimilarProductsTable } from 'src/features/novelties/components/SimilarProductsTable';
import { NoveltyProductData } from 'src/services/api/getNoveltiesBestCandidates';

type NoveltyProductCardProps = {
  product: NoveltyProductData;
  isExpanded: boolean;
  onToggleExpand: () => void;
};

export function NoveltyProductCard({
  product,
  isExpanded,
  onToggleExpand,
}: NoveltyProductCardProps): ReactElement {
  return (
    <Collapsible open={isExpanded} onOpenChange={onToggleExpand}>
      <Card className='overflow-hidden transition-all duration-200'>
        <CollapsibleTrigger asChild>
          <ProductCardHeader product={product} isExpanded={isExpanded} />
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className='bg-layout-subtle p-4'>
            <SimilarProductsTable similarities={product.similarities} />
          </div>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
}
